// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R2NLD{display:flex;justify-content:space-between;background-color:#fcfcfd;box-shadow:0px 4px 12px rgba(40,40,99,.06);width:100%;height:48px;min-height:48px;max-height:48px;padding:0 24px;position:relative;z-index:1200}.R2NLD.c_ZQw{background-color:#fdf2dc}.R2NLD.assw9{background-color:#f3f5ff}.R2NLD.UEszK{padding:0 16px}._stTn{display:flex;align-items:center;flex:1}.czjZc{display:flex;align-items:center;gap:16px}.czjZc.UEszK{gap:8px}.czjZc .cl1Mz{display:flex;justify-content:center;align-items:center;width:32px;height:32px}.czjZc .cl1Mz:empty{display:none}.czjZc .ISFaE{margin-inline-start:4px}.czjZc .nqbjR{display:flex;margin:0 8px}.iE5hP{display:flex;align-items:center;width:100%;min-width:0;flex-shrink:0;padding:8px 16px;background-color:#f3f5ff;box-shadow:0px 4px 12px rgba(40,40,99,.06)}._kKAH{display:flex;align-items:center;gap:16px}._kKAH.fLKEL{flex:1;min-width:0;justify-content:space-between;gap:8px}.yVwX4{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `R2NLD`,
	"anchorAdmin": `c_ZQw`,
	"viewMode": `assw9`,
	"mobile": `UEszK`,
	"start": `_stTn`,
	"end": `czjZc`,
	"endItem": `cl1Mz`,
	"userItem": `ISFaE`,
	"separator": `nqbjR`,
	"bannerStrip": `iE5hP`,
	"viewModeSection": `_kKAH`,
	"inStrip": `fLKEL`,
	"backBtn": `yVwX4`
};
export default ___CSS_LOADER_EXPORT___;
